import React, { useContext, useEffect, useState } from 'react'
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import { getAllCardsInventary, getAllCardsInventarySoon } from '../../Api/Products';
import { SlidersOutlined } from '@ant-design/icons';

import "./ProductList.css"
import ProductCard from '../ProductCard/ProductCard';
import { Product } from '../../Models/Product';
import SkeletonCart from '../Skeleton/SkeletonCart';
import { Input, Pagination } from 'antd';
import { Monitor } from '../../Models/Monitor';
import { addMonitor } from '../../Api/Monitor';
interface Props{
   filterTCG:string[]
   filterTipo:string[]
   filterIdioma:string[]
   setFilterOpen:React.Dispatch<React.SetStateAction<boolean>>
   loading:boolean
   setLoading:React.Dispatch<React.SetStateAction<boolean>>
   type: "soon" | "disponibles"
}

const ProductsList = ({filterIdioma, filterTCG, filterTipo, type, setLoading, loading, setFilterOpen}:Props) => {
  const [allProducts, setAllProducts] = React.useState<Product[]>([]);
  const [filteredProducts, setFilteredProducts] = React.useState<Product[]>([]);
  const [nameProduct, setNameProduct] = React.useState<string>("");
  const {sendError} = useContext(PromiseSesionContext);

      //paginate
    const [page, setPage] = useState<number>(1)
    const sizePages = 20
    
    const getProducts = async ()=>{
        try{
        setLoading(true);
        const response = type==="disponibles" ? await getAllCardsInventary() :  await getAllCardsInventarySoon();
        setAllProducts(response.products)
        setFilteredProducts(response.products); 
        console.log(response)

        setLoading(false);
        }
        catch(error){
        setLoading(false);
        sendError({type: "ERROR", data:{message:"Error al cargar el inventario.", type:"error"}})

        }
    }

  useEffect(() => {

    getProducts()

  }, []);

      const sendMonitor = async (pagina:number)=>{
        try  
        {let user:string= localStorage.getItem("user") || ""

          let monitor:Monitor={
              action:`Cambio de pagina en ${type=="soon" ? "Proximamente" : "Productos"}: Pagina ${pagina}`,
              user:user
          }
          await addMonitor(monitor)}
          catch(error){}
      }

  // useEffect para filtrar productos cuando los arrays de filtro cambien
  useEffect(() => {
    let currentFiltered = [...allProducts];

    // Filtrar por TCG
    if (filterTCG.length > 0) {
      currentFiltered = currentFiltered.filter(product => filterTCG.includes(product.tcg));
    }

    // Filtrar por Tipo
    if (filterTipo.length > 0) {
      currentFiltered = currentFiltered.filter(product => filterTipo.includes(product.type));
    }

    // Filtrar por Idioma
    if (filterIdioma.length > 0) {
      currentFiltered = currentFiltered.filter(product => filterIdioma.includes(product.language));
    }

    // 4. Filtrar por Nombre del Producto
    if (nameProduct) { // Solo si nameProduct no está vacío
      currentFiltered = currentFiltered.filter(product =>
        product.name.toLowerCase().includes(nameProduct.toLowerCase())
      );
    }

    setFilteredProducts(currentFiltered);
    console.log("filtrado",filteredProducts)
    setPage(1);
  }, [filterTCG, filterTipo, filterIdioma, allProducts, nameProduct]); // Dependencias del useEffect


  return (
    <>
    <div className='ListProducts-search'>
      <Input className='ListProduct-Imput' placeholder="Nombre del producto" value={nameProduct} onChange={(e)=>{setNameProduct(e.target.value)}} />

      <div className='ListProduct-FilterButton' onClick={()=>{setFilterOpen(true)}}>
        <SlidersOutlined />
        <span>Filtros</span>
      </div>
    </div>
    <div className='ListProductsComponent'>
        <SkeletonCart loading={loading}>
        {filteredProducts?.slice((page - 1) * sizePages, page * sizePages).map((producto:Product) =>  <ProductCard type={type} key={producto.id + " " + producto.name} producto={producto} />)}


        
        </SkeletonCart>


    </div>

          <div className='centerPaginate'>
            {filteredProducts?.length >sizePages && <Pagination defaultCurrent={1} onChange={(newPage, newPageSize)=>{sendMonitor(newPage);  setPage(newPage);window.scrollTo({ top: 0, behavior: 'smooth' });}} current={page} total={filteredProducts?.length} pageSize={sizePages} showSizeChanger={false} />}
        </div>
    </>

  )
}

export default ProductsList